import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined";
import { useTranslations } from "hooks/useTranslations";

export const PaymentDisclaimer = () => {
  const {
    translations: {
      paymentMethod: { paymentDisclaimer },
    },
  } = useTranslations();
  return (
    <List sx={{ display: { xs: "none", md: "initial" }, mt: -2, mb: 0 }}>
      <ListItem sx={{ pl: { md: 0 }, alignItems: "start" }}>
        <ListItemIcon sx={{ minWidth: 24, color: "grey.600" }}>
          <ReportOutlinedIcon sx={{ fontSize: 16 }} color="primary" />
        </ListItemIcon>
        <ListItemText sx={{ maxWidth: 376, mt: 0 }}>
          <Typography
            variant="titleExtraSmall"
            weight="bold"
            sx={{ color: "primary.main" }}
          >
            {paymentDisclaimer.text}
          </Typography>
        </ListItemText>
      </ListItem>
    </List>
  );
};
